import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vfs-dev-imp-steps',
  templateUrl: './dev-imp-steps.component.html',
  styleUrls: ['./dev-imp-steps.component.scss']
})
export class DevImpStepsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
